import Vue from 'vue';
import VideoComponent from '@app/components/Video.vue';
export default Vue.extend({
    components: {
        VideoComponent: VideoComponent
    },
    props: {
        block: Object
    },
    computed: {
        image: function () {
            if (this.block.images.length == 1 && this.logo != null) {
                return false;
            }
            else {
                return true;
            }
        },
        logo: function () {
            return this.$helpers.taggedFirst(this.block.images, 'logo');
        }
    }
});
